import { GridItemChangeEvent } from '@progress/kendo-react-grid';
import { addDays } from 'date-fns';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import usePeriodsTableColumns from 'src/assets/static/view_periods/usePeriodsTableColumns';
import GridWrapper from 'src/components/GridWrapper';
import useViewCalendarYear from 'src/hooks/useViewCalendarYear';
import BudgetPeriodsTableGridToolbar from './BudgetPeriodsTableGridToolbar';

const BudgetPeriodsTable = () => {
  const columns = usePeriodsTableColumns();
  const { t } = useTranslation();
  const { selectedFYPeriod, setSelectedFYPeriod, selectedFYPeriodWithErrors } =
    useViewCalendarYear();

  const handleItemChange = useCallback(
    (e: GridItemChangeEvent) => {
      const { field = '', value, dataItem } = e;
      const startDate = value ? addDays(value, 1) : null;
      if (!dataItem) return;

      setSelectedFYPeriod((prev) => {
        let currentIndex = -1;
        return {
          ...prev,
          periods: prev.periods.map((period, index) => {
            if (period.rowId === dataItem.rowId) {
              currentIndex = index + 1;
              return { ...period, [field]: value };
            } else if (currentIndex === index) {
              return { ...period, startDate };
            }
            return period;
          }),
        };
      });
    },
    [setSelectedFYPeriod]
  );

  const selectedPeriodsLength = selectedFYPeriod?.periods?.length ?? 0;
  const accountingPeriodsText = t(
    'Showing {{count}} Accounting {{period}} for selected Fiscal Year',
    {
      count: selectedPeriodsLength,
      period: selectedPeriodsLength > 1 ? t('Periods') : t('Period'),
    }
  );

  return (
    <div className="mt-3 md:ml-3">
      <p className="p-2">{accountingPeriodsText}</p>
      <GridWrapper
        columns={columns}
        className="noCursorPointer"
        DataItemKey="rowId"
        dataSource={selectedFYPeriodWithErrors?.periods ?? []}
        onItemChange={handleItemChange}
        gridToolbarChildren={<BudgetPeriodsTableGridToolbar />}
        hideScrollBar
      />
    </div>
  );
};

export default BudgetPeriodsTable;
